export default "__VITE_ASSET__UcTbcrfX__"